import { render, staticRenderFns } from "./duo_custom_answer_input.vue.js?vue&type=template&id=5fa98772&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_custom_answer_input.vue?vue&type=template&id=5fa98772&vue3"
import script from "./duo_custom_answer_input.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_custom_answer_input.vue?vue&type=script&lang=js&vue3"
export * from "./duo_custom_answer_input.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_custom_answer_input.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports